<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <!-- <i class="material-icons cusIconSize">&#xE7FD;</i> -->
          <img src="./assets/images/Proctoring-Management_Icon.png" alt="" />
          <span>Manage Office</span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span>Add Office</span>
                </p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="col s12 m4 l4">
            <form class="example-form">
              <md-form-field class="example-full-width">
                <input type="text" placeholder="Office Name" mdInput [formControl]="officeName" maxlength="50">
              </md-form-field>
            </form>
          </div>

          <div class="col s12 m8 l8">
            <div class="button-row">
              <button [disabled]="!officeName.value" md-raised-button class="glbAdminBtnCls1" (click)="onAddOffice()">
                <i class="material-icons">&#xE145;</i>Add Office</button>
            </div>
          </div>
        </md-card-content>
      </md-card>

      <!-- grid code -->
      <div class="cusPaginationContainer example-container" [ngClass]="{'hide-grid':recordCount > 0}">
        <p class="nodataFound"> No Results Found</p>
      </div>

      <div class="cusPaginationContainer example-container" [ngClass]="{'hide-grid':recordCount < 1}">

        <md-table #table [dataSource]="dataSource" mdSort>
          <md-header-row *mdHeaderRowDef="displayedColumns"></md-header-row>
          <md-row *mdRowDef="let row; columns: displayedColumns;"></md-row>

          <!-- Office Name Column -->
          <ng-container mdColumnDef="name">
            <md-header-cell *mdHeaderCellDef md-sort-header>OFFICE NAME</md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.name}} </md-cell>
          </ng-container>

          <!-- Action Column -->
          <ng-container mdColumnDef="Action">
            <md-header-cell *mdHeaderCellDef>ACTIONS</md-header-cell>
            <md-cell *mdCellDef="let element">
              <a href="javascript:void(0)" (click)="onRemove(element)">Remove</a>
            </md-cell>
          </ng-container>
        </md-table>

      </div>

      <!-- grid code end -->
    </div>
  </div>

</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-office/adm-manage-office.component.html